import React, { PureComponent } from 'react';
import _ from 'lodash';
import { withRedux } from '../hoc';
import { switchLanguageAction } from '../actions/languages';

const mapStateToProps = state => {
  return {
    languages: _.get(state, 'languages')
  };
};

const actions = {
  switchLanguageAction
};

@withRedux(mapStateToProps, actions)
export default class LanguageSwitcher extends PureComponent {
  handleSwitchLanguage = language => {
    document.querySelector('html').setAttribute('lang', language);
    this.props.actions.switchLanguageAction(language);
  };
  render() {
    if (_.size(this.props.languages.data) <= 1) return null;
    return (
      <ul className="language-switcher">
        {_.map(this.props.languages.data, language => {
          const { key, name } = language;
          return (
            <li
              key={key}
              className={key === this.props.languages.currentActive ? 'active' : ''}
              onClick={() => this.handleSwitchLanguage(key)}
            >
              {name}
            </li>
          );
        })}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.js